import React from 'react';
import { Link } from 'react-router-dom';
import BrandLogo from '@components/BrandLogo';
import './style.scss';

const FOOTER_LINKS = [
    { to: '/about', label: 'About' },
    { to: '/privacy', label: 'Privacy' },
    { to: '/terms', label: 'Terms' },
];

const FooterInfo = () => {
    const version = process.env.REACT_APP_VERSION;

    return (
        <footer className="site-footer mobile-hide">
            <div className="site-footer__inner">
                <div className="site-footer__brand">
                    <Link to="/" className="site-footer__logo-link">
                        <BrandLogo className="site-footer__logo" alt="Khaata POS" />
                        {/* <span className="site-footer__logo-text">Khaata POS</span> */}
                    </Link>
                    <p className="site-footer__tagline">
                        Smart billing for restaurants, cafes, and hospitality.
                    </p>
                </div>

                <nav className="site-footer__nav" aria-label="Footer navigation">
                    {FOOTER_LINKS.map(({ to, label }) => (
                        <Link key={to} to={to} className="site-footer__nav-link">
                            {label}
                        </Link>
                    ))}
                </nav>
            </div>

            <div className="site-footer__bottom">
                <p className="site-footer__copyright">
                    © {new Date().getFullYear()} Khaata POS. All rights reserved.
                </p>
                <p className="site-footer__credit">
                    Designed by{' '}
                    <a
                        href="https://iitnirvana.com"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="site-footer__credit-link"
                    >
                        iitnirvana.com
                    </a>
                    {version && <span className="site-footer__version"> · v{version}</span>}
                </p>
            </div>
        </footer>
    );
};

export default FooterInfo;
